import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)


let isPhone = function () {
  let userAgentInfo = navigator.userAgent;
  let Agents = ['Android', "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  let flag = true;
  
  // 判断手机的系统
  // if(userAgentInfo.indexOf("Safari")>=0 && userAgentInfo.indexOf("iPhone")>=0){
  //   localStorage.setItem('userPhone', 'iPhoneSafari')
  // }
  if(userAgentInfo.indexOf("iPhone")>=0){
    localStorage.setItem('userPhone', 'iPhone')
  }
  else if(userAgentInfo.indexOf("Android")>=0){
    localStorage.setItem('userPhone', 'Android')
  }
  else{
    localStorage.setItem('userPhone', 'Android')
  }

  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) >= 0) {
      flag = false;
      break;
    }
  }
  return flag
}
let isPc = isPhone();
localStorage.setItem('isPc', isPc)

const routePC = [
  {
    path: '/',
    name: 'Home',
    component: resolve => require(['../../src/components/PC/Home.vue'], resolve),
    meta: {
      title: 'Off-the-Plan Sales CRM & Stock Management | Arcanite',
      description: 'Arcanite is the off-the-plan sales platform for Australian property developers and agents. Manage stock, channels and contracts in one place.',
      ogTitle: 'The off-the-plan CRM and sales operating system',
      ogDescription: 'One live stock position across every sales channel — so you never sell the same lot twice.',
      ogImage: '/og/og-default.png',
      softwareApp: { name: 'Arcanite' }
    }
  },
  {
    path: '/bookdemo',
    name: 'Home',
    component: resolve => require(['../../src/components/PC/Home.vue'], resolve)
  },
  {
    path: '/FB',
    name: 'Home',
    component: resolve => require(['../../src/components/PC/Home.vue'], resolve)
  },
  {
    path: '/:socialmedia/bookdemo',
    name: 'Home',
    component: resolve => require(['../../src/components/PC/Home.vue'], resolve)
  },
  {
    path: '/products(.*)',
    name: 'Products',
    component: resolve => require(['../../src/components/PC/Products.vue'], resolve),
    meta: {
      title: 'Arcanite Products | Sales & Project Marketing Tools',
      description: 'Explore the Arcanite suite of products for property developers and real estate agents, built to streamline off-the-plan project sales from listing to close.',
      ogImage: '/og/og-default.png',
      softwareApp: { name: 'Arcanite' }
    }
  },
  {
    path: '/pricing(.*)',
    name: 'Pricing',
    component: resolve => require(['../../src/components/PC/Pricing.vue'], resolve),
    meta: {
      title: 'Pricing | Arcanite Off-the-Plan Sales CRM',
      description: 'Arcanite pricing scales with your team, from Solo to Enterprise, with per-seat monthly and yearly plans built around your project pipeline.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/privacyPolicy(.*)',
    name: 'PrivacyPolicy',
    component: resolve => require(['../../src/components/PC/PrivacyPolicy.vue'], resolve),
    meta: {
      title: 'Privacy Policy | Arcanite',
      description: 'Read the Arcanite Privacy Policy to learn how we collect, use and protect your personal information.',
      ogImage: '/og/og-default.png'
    }
  },

  // pc端路由重定向
  {
    path: '/resources(.*)',
    redirect:'/blogs',
  },
  {
    path: '/resourceDetails/:id/(.*)',
    redirect:'/blogDetails/:id',
  }, 
  {
    path: '/resourceDetail/:id/(.*)',
    redirect: '/blogDetails/:id'
  },

   {
    path: '/blogs(.*)',
    name: 'Blogs',
    component: resolve => require(['../../src/components/PC/Blogs.vue'], resolve),
    meta: {
      title: 'Off-the-Plan Sales Insights & Guides | Arcanite Blog',
      description: 'Practical guidance on off-the-plan sales, stock management, presale reporting and agent channel control for Australian property developers.',
      ogImage: '/og/og-blog.png'
    }
  }, {
    path: '/features(.*)',
    name: 'Features',
    component: resolve => require(['../../src/components/PC/Features.vue'], resolve),
    meta: {
      title: 'Features | Off-the-Plan Sales Software | Arcanite',
      description: 'Stock and allotment management, agent channel control, contract flow and presale reporting - built for Australian off-the-plan property sales.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/blogDetails/:id/(.*)',
    name: 'BlogDetails',
    component: resolve => require(['../../src/components/PC/BlogDetail.vue'], resolve),
    // meta: {
    //   title: 'Home Page - Example App',
    //   metaTags: [
    //     {
    //       name: 'description',
    //       property: 'og:description',
    //       content: 'The home page of our example app.'
    //     },
    //     {
    //       name: 'type',
    //       property: 'og:type',
    //       content: 'Arti'
    //     }
    //   ]
    // }
  }, 
  // {
  //   path: '/blogDetail/:id',
  //   name: 'BlogDetail',
  //   component: resolve => require(['../../src/components/PC/BlogDetail.vue'], resolve),
  // },
  {
    path: '/termsAndConditions(.*)',
    name: 'TermsAndConditions',
    component: resolve => require(['../../src/components/PC/TermsConditions.vue'], resolve),
    meta: {
      title: 'Terms & Conditions | Arcanite',
      description: 'Read the terms and conditions governing your use of the Arcanite website and application.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/servicesAgreement(.*)',
    name: 'ServicesAgreement',
    component: resolve => require(['../../src/components/PC/ServicesAgreement.vue'], resolve),
    meta: {
      title: 'Services Agreement | Arcanite',
      description: 'The services agreement outlining the terms of use and service for Arcanite platforms.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/arcaniteConnect(.*)',
    name: 'ArcaniteConnect',
    component: resolve => require(['../../src/components/PC/ArcaniteConnect.vue'], resolve),
    meta: {
      title: 'Arcanite Connect | Project Sales Admin & Reporting',
      description: 'Manage stock releases, approve reservations, control agent channels and report on presales from one admin dashboard.',
      ogImage: '/og/og-arcanite-connect.png',
      softwareApp: { name: 'Arcanite Connect' }
    }
  },
  {
    path: '/arcanitePartners(.*)',
    name: 'ArcanitePartner',
    component: resolve => require(['../../src/components/PC/ArcanitePartner.vue'], resolve),
    meta: {
      title: 'Arcanite Partners | Developer & Agency Network',
      description: 'Connect property developers with project marketing agencies, and manage every channel relationship from one place.',
      ogImage: '/og/og-arcanite-partners.png',
      softwareApp: { name: 'Arcanite Partners' }
    }
  },
  {
    path: '/arcanite(.*)',
    name: 'Arcanite',
    component: resolve => require(['../../src/components/PC/Arcanite.vue'], resolve),
    meta: {
      title: 'Arcanite App | Off-the-Plan Sales App for Agents',
      description: 'Live stock, project collateral and instant reservations for project sales agents. Available on iOS and Android.',
      ogImage: '/og/og-arcanite-app.png',
      softwareApp: { name: 'Arcanite' }
    }
  },
  {
    path: '/dragonVR(.*)',
    name: 'DragonVR',
    component: resolve => require(['../../src/components/PC/DragonVR.vue'], resolve),
    meta: {
      title: 'DragonVR | Bringing Off-The-Plan Properties to Life',
      description: 'DragonVR by Arcanite brings off-the-plan properties to life with immersive virtual reality experiences for buyers.',
      ogImage: '/og/og-default.png'
    }
  },
  // {
  //   path: '/equimate',
  //   name: 'Equimate',
  //   component: resolve => require(['../../src/components/PC/Equimate.vue'], resolve)
  // },
  {
	path: '/marketplace(.*)',
	name: 'Marketplace',
	component: resolve => require(['../../src/components/PC/Marketplace.vue'], resolve),
    meta: {
      title: 'Project Marketplace | Off-the-Plan Opportunities',
      description: 'Browse off-the-plan projects seeking sales channels, or list your project to reach agencies across Australia.',
      ogImage: '/og/og-project-marketplace.png',
      softwareApp: { name: 'Arcanite Marketplace' }
    }
  },
  {
    path: '/aboutUs(.*)',
    name: 'AboutUs',
    component: resolve => require(['../../src/components/PC/AboutUs.vue'], resolve),
    meta: {
      title: 'About Arcanite | Project Marketing Technology',
      description: 'Arcanite builds sales technology for Australian property developers and project marketing agencies. Based in North Sydney.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/contact(.*)',
    name: 'Contact',
    component: resolve => require(['../../src/components/common/Contact.vue'], resolve),
    meta: {
      title: 'Contact Arcanite | North Sydney, NSW',
      description: 'Get in touch with the Arcanite team in North Sydney, or book a free demo of the off-the-plan sales platform.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/sitemap(.*)',
    name: 'Sitemap',
    component: resolve => require(['../../src/components/PC/Sitemap.vue'], resolve)
  },
  {
    path: '*',
    name: 'NotFound',
    component: resolve => require(['../../src/components/common/NotFound.vue'], resolve),
    meta: {
      title: 'Page not found | Arcanite',
      description: "The page you're looking for doesn't exist. Find Arcanite's off-the-plan sales platform, or book a free demo.",
      ogImage: '/og/og-default.png'
    }
  }
]

const routeAPP = [
  {
    path: '/',
    name: 'Home',
    component: resolve => require(['../../src/components/APP/Home.vue'], resolve),
    meta: {
      title: 'Off-the-Plan Sales CRM & Stock Management | Arcanite',
      description: 'Arcanite is the off-the-plan sales platform for Australian property developers and agents. Manage stock, channels and contracts in one place.',
      ogTitle: 'The off-the-plan CRM and sales operating system',
      ogDescription: 'One live stock position across every sales channel — so you never sell the same lot twice.',
      ogImage: '/og/og-default.png',
      softwareApp: { name: 'Arcanite' }
    }
  },
  {
    path: '/bookdemo',
    name: 'Home',
    component: resolve => require(['../../src/components/APP/Home.vue'], resolve)
  },
  {
    path: '/FB',
    name: 'Home',
    component: resolve => require(['../../src/components/APP/Home.vue'], resolve)
  },
  {
    path: '/:socialmedia/bookdemo',
    name: 'Home',
    component: resolve => require(['../../src/components/APP/Home.vue'], resolve)
  },
  {
    path: '/arcaniteConnect(.*)',
    name: 'ArcaniteConnect',
    component: resolve => require(['../../src/components/APP/ArcaniteConnect.vue'], resolve),
    meta: {
      title: 'Arcanite Connect | Project Sales Admin & Reporting',
      description: 'Manage stock releases, approve reservations, control agent channels and report on presales from one admin dashboard.',
      ogImage: '/og/og-arcanite-connect.png',
      softwareApp: { name: 'Arcanite Connect' }
    }
  },
  {
    path: '/arcanitePartners(.*)',
    name: 'ArcanitePartner',
    component: resolve => require(['../../src/components/APP/ArcanitePartner.vue'], resolve),
    meta: {
      title: 'Arcanite Partners | Developer & Agency Network',
      description: 'Connect property developers with project marketing agencies, and manage every channel relationship from one place.',
      ogImage: '/og/og-arcanite-partners.png',
      softwareApp: { name: 'Arcanite Partners' }
    }
  },
  {
    path: '/arcanite(.*)',
    name: 'Arcanite',
    component: resolve => require(['../../src/components/APP/Arcanite.vue'], resolve),
    meta: {
      title: 'Arcanite App | Off-the-Plan Sales App for Agents',
      description: 'Live stock, project collateral and instant reservations for project sales agents. Available on iOS and Android.',
      ogImage: '/og/og-arcanite-app.png',
      softwareApp: { name: 'Arcanite' }
    }
  },
  {
    path: '/dragonVR(.*)',
    name: 'DragonVR',
    component: resolve => require(['../../src/components/APP/DragonVR.vue'], resolve),
    meta: {
      title: 'DragonVR | Bringing Off-The-Plan Properties to Life',
      description: 'DragonVR by Arcanite brings off-the-plan properties to life with immersive virtual reality experiences for buyers.',
      ogImage: '/og/og-default.png'
    }
  },
  // {
  //   path: '/equimate',
  //   name: 'Equimate',
  //   component: resolve => require(['../../src/components/APP/Equimate.vue'], resolve)
  // },
  {
    path: '/marketplace(.*)',
    name: 'Marketplace',
    component: resolve => require(['../../src/components/APP/Marketplace.vue'], resolve),
    meta: {
      title: 'Project Marketplace | Off-the-Plan Opportunities',
      description: 'Browse off-the-plan projects seeking sales channels, or list your project to reach agencies across Australia.',
      ogImage: '/og/og-project-marketplace.png',
      softwareApp: { name: 'Arcanite Marketplace' }
    }
  },
  {
    path: '/products(.*)',
    name: 'Products',
    component: resolve => require(['../../src/components/APP/Products.vue'], resolve),
    meta: {
      title: 'Arcanite Products | Sales & Project Marketing Tools',
      description: 'Explore the Arcanite suite of products for property developers and real estate agents, built to streamline off-the-plan project sales from listing to close.',
      ogImage: '/og/og-default.png',
      softwareApp: { name: 'Arcanite' }
    }
  },
  {
    path: '/pricing(.*)',
    name: 'Pricing',
    component: resolve => require(['../../src/components/APP/Pricing.vue'], resolve),
    meta: {
      title: 'Pricing | Arcanite Off-the-Plan Sales CRM',
      description: 'Arcanite pricing scales with your team, from Solo to Enterprise, with per-seat monthly and yearly plans built around your project pipeline.',
      ogImage: '/og/og-default.png'
    }
  },

  //app路由重定向
  {
    path: '/resources(.*)',
    redirect:'/blogs',
  },
  {
    path: '/resourceDetail/:id/(.*)',
    redirect:'/blogDetails/:id',
  },
  {
    path: '/resourceDetails/:id/(.*)',
    redirect:'/blogDetails/:id',
  },
  {
    path: '/blogs(.*)',
    name: 'Blogs',
    component: resolve => require(['../../src/components/APP/Blogs.vue'], resolve),
    meta: {
      title: 'Off-the-Plan Sales Insights & Guides | Arcanite Blog',
      description: 'Practical guidance on off-the-plan sales, stock management, presale reporting and agent channel control for Australian property developers.',
      ogImage: '/og/og-blog.png'
    }
  },
  // {
  //   path: '/BlogDetail/:id',
  //   name: 'BlogDetail',
  //   component: resolve => require(['../../src/components/APP/BlogsContent.vue'], resolve)
  // },
  {
    path: '/blogDetails/:id/(.*)',
    name: 'BlogDetails',
    component: resolve => require(['../../src/components/APP/BlogsContent.vue'], resolve)
  },
  {
    path: '/privacyPolicy(.*)',
    name: 'PrivacyPolicy',
    component: resolve => require(['../../src/components/APP/PrivacyPolicy.vue'], resolve),
    meta: {
      title: 'Privacy Policy | Arcanite',
      description: 'Read the Arcanite Privacy Policy to learn how we collect, use and protect your personal information.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/servicesAgreement(.*)',
    name: 'ServicesAgreement',
    component: resolve => require(['../../src/components/APP/ServicesAgreement.vue'], resolve),
    meta: {
      title: 'Services Agreement | Arcanite',
      description: 'The services agreement outlining the terms of use and service for Arcanite platforms.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/footernav',
    name: 'FooterNav',
    component: resolve => require(['../../src/components/APP/FooterNav.vue'], resolve)
  }, {
    path: '/termsAndConditions(.*)',
    name: 'TermsAndConditions',
    component: resolve => require(['../../src/components/APP/TermsConditions.vue'], resolve),
    meta: {
      title: 'Terms & Conditions | Arcanite',
      description: 'Read the terms and conditions governing your use of the Arcanite website and application.',
      ogImage: '/og/og-default.png'
    }
  },
   {
    path: '/aboutus(.*)',
    name: 'AboutUs',
    component: resolve => require(['../../src/components/APP/AboutUs.vue'], resolve),
    meta: {
      title: 'About Arcanite | Project Marketing Technology',
      description: 'Arcanite builds sales technology for Australian property developers and project marketing agencies. Based in North Sydney.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/contact(.*)',
    name: 'Contact',
    component: resolve => require(['../../src/components/common/Contact.vue'], resolve),
    meta: {
      title: 'Contact Arcanite | North Sydney, NSW',
      description: 'Get in touch with the Arcanite team in North Sydney, or book a free demo of the off-the-plan sales platform.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/features(.*)',
    name: 'Features',
    component: resolve => require(['../../src/components/APP/Features.vue'], resolve),
    meta: {
      title: 'Features | Off-the-Plan Sales Software | Arcanite',
      description: 'Stock and allotment management, agent channel control, contract flow and presale reporting - built for Australian off-the-plan property sales.',
      ogImage: '/og/og-default.png'
    }
  },
  {
    path: '/sitemap(.*)',
    name: 'Sitemap',
    component: resolve => require(['../../src/components/APP/Sitemap.vue'], resolve)
  },
  {
    path: '*',
    name: 'NotFound',
    component: resolve => require(['../../src/components/common/NotFound.vue'], resolve),
    meta: {
      title: 'Page not found | Arcanite',
      description: "The page you're looking for doesn't exist. Find Arcanite's off-the-plan sales platform, or book a free demo.",
      ogImage: '/og/og-default.png'
    }
  }
]

const router = new Router({
	// mode: isPc ? 'history':'hash',
	mode: 'history',
  routes: isPc ? routePC : routeAPP,
})

router.beforeEach((to, from, next) => {
  const realPath = decodeURIComponent(to.path);
  if (realPath.includes('/bookdemo/')) {
    const base = to.path.slice(0, realPath.indexOf('/bookdemo')) || '';
    const demoUrl = `${base}/bookdemo`
    history.replaceState({ popup: 'open' }, '', demoUrl) 
    next(demoUrl);
  } else {
    next();
  }
})

export default router
